<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { throttle } from 'lodash-es';
import RestechAddonAccommodations from '../../../components/ski/restech/RestechAddonAccommodations';

export default {
  name: 'RestechAddons',
  components: {
    RestechAddonAccommodations,
  },
  data() {
    return {
      headers: [
        { text: 'Id', class: 'px-2', value: 'id' },
        { text: 'Description', class: 'px-2', value: 'description' },
        { text: 'Mandatory', class: 'px-2', value: 'isMandatory' },
        { text: 'Used', class: 'px-2 text-xs-center', value: 'accommodationCount' },
        { text: 'Bookable', class: 'px-2', value: 'isBookable' },
        { text: 'Twenty Extra Id', class: 'px-2', value: 'twentyExtraId' },
      ],
      pagination: {
        rowsPerPage: 20,
        sortBy: 'description',
      },
      paginationRowsPerPage: [
        20,
        50,
        { text: 'All', value: -1 },
      ],
    };
  },
  computed: {
    ...mapState({
      xmlChannels: state => state.restech.xmlChannels,
      addon: state => state.restech.addons.addon,
      addons: state => state.restech.addons.items,
      loading: state => state.restech.addons.loading,
      xmlChannelId: state => state.restech.addons.xmlChannelId,
      update: state => state.restech.addons.update,
    }),
    ...mapGetters({
      filteredAddons: 'restech/getAddons',
    }),
  },
  methods: {
    ...mapActions({
      search: 'restech/searchAddons',
      setXmlChannel: 'restech/setXmlChannel',
      getAddons: 'restech/getAddonsByXmlChannelId',
      updateAddon: 'restech/updateAddon',
      showAddonAccommodationModal: 'restech/showAddonAccommodationModal',
    }),
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    changeAddon(addon) {
      const updateAddon = {
        id: addon.id,
        xmlChannelId: addon.xmlChannelId,
        twentyExtraId: addon.twentyExtraId,
        isBookable: addon.isBookable,
      };
      this.updateAddon(updateAddon);
    },
    throttleSearch: throttle(function input(search) {
      this.search(search);
    }, 250, { leading: false }),
  },
};
</script>

<template>
  <v-card>
    <v-container fluid>
      <v-layout row>
        <v-flex xs3>
          <v-select
            @input="setXmlChannel"
            :value="xmlChannels.xmlChannel"
            :items="xmlChannels.items"
            :loading="xmlChannels.loading"
            :disabled="xmlChannels.loading"
            :error-messages="xmlChannels.error ? $t('skistar.resorts.error') : undefined"
            :error="!!xmlChannels.error"
            label="Destinations"
            item-value="id"
            item-text="webservice"
          >
          </v-select>
          <restech-addon-accommodations
            v-if="addon.showProductNames"
            :id="addon.id"
            :description="addon.description"
            :accommodations="addon.productNames"
            :show="addon.showProductNames"
          />
        </v-flex>
        <v-flex xs6 pl-4>
          <v-text-field
            @input="throttleSearch"
            append-icon="search"
            label="Search"
            clearable
          />
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <v-data-table
            :items="filteredAddons"
            :headers="headers"
            :loading="loading"
            :pagination.sync="pagination"
            :rows-per-page-items="paginationRowsPerPage"
            no-results-text="No adddons"
            class="print"
            item-key="id"
            must-sort
          >
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  @click="changeSort(header.value)"
                  :key="header.text"
                  :class="['column sortable',
                      pagination.descending ? 'desc' : 'asc',
                      header.value === pagination.sortBy ? 'active' : '',
                      header.class ? header.class : '',
                      header.align ? 'text-xs-' + header.align : 'text-xs-left'
                    ]"
                >
                  {{ header.text }}
                  <v-icon small>arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="px-1">{{ props.item.id }}</td>
                <td class="px-2">{{ props.item.description }}</td>
                <td class="px-2">{{ props.item.isMandatory }}</td>
                <td class="px-2 text-xs-center">
                  <v-btn
                    @click="showAddonAccommodationModal(props.item)"
                    color="primary"
                    round
                    small
                  >
                    {{ props.item.productNames.length }}
                  </v-btn>
                </td>
                <td class="px-2 pt-3">
                  <v-checkbox
                    v-model="props.item.isBookable"
                    @change="changeAddon(props.item)"
                    :loading="update.inProgressItems[props.item.id]"
                  />
                </td>
                <td class="px-2">
                  <v-text-field
                    v-model="props.item.twentyExtraId"
                    @change="changeAddon(props.item)"
                    :loading="update.inProgressItems[props.item.id]"
                  />
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>



// WEBPACK FOOTER //
// src/pages/ski/restech/RestechAddons.vue